import { render, staticRenderFns } from "./oldChange.vue?vue&type=template&id=a56d9dba&scoped=true"
import script from "./oldChange.vue?vue&type=script&lang=js"
export * from "./oldChange.vue?vue&type=script&lang=js"
import style0 from "./oldChange.vue?vue&type=style&index=0&id=a56d9dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56d9dba",
  null
  
)

export default component.exports